var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6074 21.4746L19.4531 3.32031C17.5 1.36719 14.3457 1.36719 12.3926 3.32031C10.4395 5.27344 10.4395 8.42773 12.3926 10.3809L27.0215 25L12.3926 39.6191C10.4395 41.5723 10.4395 44.7266 12.3926 46.6797C14.3457 48.6328 17.5 48.6328 19.4531 46.6797L37.6074 28.5254C39.5508 26.582 39.5508 23.418 37.6074 21.4746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.49f195dc2a62ce9ac788fec7fe8803dc.svg";
export { ForwardRef as ReactComponent };